import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncMaterialIconSharp = createAsyncIcon(() => import('./MaterialIconSharp'));

export default AsyncMaterialIconSharp;

AsyncMaterialIconSharp.displayName = 'AsyncMaterialIconSharp';
